<template>
    <div>
        <div id="taskDialog">
            <el-dialog title="公告面板" :visible.sync="dialogVisible" top="20px" width="1000px"
                :before-close="noticePanelClose">
                <!-- <el-tabs type="border-card">
                <el-tab-pane label="公告信息" id="waitPane"> -->
                <div v-if="noticeList.length < 1" style="text-align:center">暂无内容</div>
                <div v-for="item in noticeList" :key="item.punIndex">
                    <el-card class="box-card">
                        <div slot="header" id="btnBox">
                            <span>{{ item.punTitle }}</span>
                            <span class="spanMargin statusColor"> 状态:{{ getTaskStatus(item.punSendstate) }}</span>
                        </div>
                        <div class="tpContentBox">
                            <div>
                                <p @click="getFuWenBen(item.punTitle, item.punContent, item.punIndex)"
                                    style="height:50px; overflow: hidden;" v-html="item.punContent"></p>
                                <p class="tpContentBoxP2">
                                    <span v-if="item.createTime" class="spanMargin">
                                        {{ $common.getLocalTime(item.createTime, true) }}
                                    </span>
                                    <span>{{ item.createrName }}</span>
                                    <span v-if="item.punStarttime">&nbsp;开始时间:
                                        {{ $common.getLocalTime(item.punStarttime) }}
                                    </span>
                                    <span v-if="item.punValiduntil">&nbsp;结束时间:
                                        {{ $common.getLocalTime(item.punValiduntil) }}
                                    </span>
                                </p>
                                <p class="tpContentBoxP2">已查看：{{ item.readerName }}</p>
                            </div>
                        </div>
                    </el-card>
                </div>
                <!-- </el-tab-pane>
            </el-tabs> -->

                <span slot="footer" class="dialog-footer">
                    <el-button @click="noticePanelClose">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <el-dialog :title="noticeContentTitle" id="didia" :visible.sync="noticeContentDialog" width="950px"
            :modal-append-to-body="true">
            <div class="noticemain" v-html="noticeContentData"
                style="-webkit-user-select:none ; -moz-user-select:none; margin: 10px;"></div>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="judgeIsRead()" type="primary" @click="addReadPeopleBtn()">已阅读</el-button>
                <el-button @click="noticeContentDialog = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    addReaderPeople
} from "@/service/api.js";
export default {
    name: 'NoticePanel',
    props: ["noticeList"],
    data() {
        return {
            colorList: ['#00BFDD', '#7874CE', '#FFAB00', '#E64C66'],    //一级，二级，三级，四级
            dialogVisible: false,
            options: [{
                value: '1',
                label: '1级'
            }, {
                value: '2',
                label: '2级'
            }, {
                value: '3',
                label: '3级'
            }, {
                value: '4',
                label: '4级'
            }],
            noticeContentDialog: false,
            noticeContentData: "",
            noticeContentTitle: "",
            punIndex: "",//选择的通知
            opmId: JSON.parse(sessionStorage.getItem('userInfo')).opmId

        }
    },
    methods: {
        //富文本弹窗
        getFuWenBen(title, data, index) {
            this.noticeContentDialog = true
            this.noticeContentData = data
            this.noticeContentTitle = title
            this.punIndex = index

        },
        //去预警页面
        goEarlyWarningPage(e) {
            if (e && e != null && e != '') {
                this.$emit('getTaskParam', e)
            }
        },

        //向父级推送
        noticePanelClose() {
            this.dialogVisible = false
            this.$emit('noticePanelClose', this.dialogVisible)
        },

        //获取颜色
        getColor(str) {
            str = str.toString()
            if (str == 1 || str == '一' || str.indexOf('1') > 0 || str.indexOf('一') > 0) {
                return this.colorList[0]
            } else if (str == 2 || str == '二' || str.indexOf('2') > 0 || str.indexOf('二') > 0) {
                return this.colorList[1]
            } else if (str == 3 || str == '三' || str.indexOf('3') > 0 || str.indexOf('三') > 0) {
                return this.colorList[2]
            } else {
                return this.colorList[3]
            }
        },
        //获取状态0.初始1.关闭（发起人）2.完成3.拒绝（接收人）
        getTaskStatus(num) {
            if (num == 0) {
                return '停用'
            } else if (num == 1) {
                return '启用'
            }
        },
        async addReadPeopleBtn() {
            this.noticeContentDialog = false
            let params = {
                ids: [
                    this.punIndex
                ],
            }

            let responseData = await this.$http.addReaderPeople(params);
            console.log(responseData)
            this.$emit('freshGongGao')
        },
        judgeIsRead() {
            let sel = ''
            for (let item of this.noticeList) {
                if (item.punIndex == this.punIndex) {//找到选择的公告
                    sel = item
                    break;
                }
            }
            console.log(sel)
            if (sel.reader == null || sel.reader == '') {
                return false
            }

            if (sel.reader.includes(String(this.opmId))) {
                return true
            } else {
                return false
            }




        }


    },
    created() {
        if (this.noticeList) this.dialogVisible = true

    },
}
</script>

<style scoped>
::v-deep #taskDialog .el-dialog {
    height: 96%;
    overflow: auto;
    margin-bottom: 0;
}

::v-deep #taskDialog .el-dialog__body {
    height: 82%;
    overflow: auto;
}

::v-deep .el-dialog__body::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}

::v-deep .el-dialog__body::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #c1c1c1;
}

::v-deep .el-dialog__body::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 1);
    border-radius: 10px;
    background: #f1f1f1;
}

#createDialog ::v-deep .el-dialog {
    height: 50%;
}

#createDialog ::v-deep .el-form {
    margin-top: 20px;
    margin-bottom: 40px;
}

.el-tabs {
    height: 95%;
}

::v-deep .el-tabs__nav-wrap {
    margin-bottom: 0;
}

::v-deep .el-tabs__nav {
    width: 100%;
}

::v-deep .el-tabs__item {
    width: 50%;
    font-size: 20px;
    text-align: center;
}

::v-deep .el-tabs--border-card>.el-tabs__content {
    height: 94%;
    overflow: auto;
}

::v-deep .el-tabs__content::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
}

::v-deep .el-tabs__content,
::v-deep #taskDialog .el-dialog {
    /* 隐藏滚动条 */
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
}

/* ::v-deep .el-card {
    margin-bottom: 20px;
} */

::v-deep .el-card:last-child {
    margin-bottom: 8px;
}

::v-deep .el-card__header {
    padding: 0;
}

#btnBox {
    padding: 8px 20px;
    color: #409EFF;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
}

.tpContentBox {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.tpContentBox .tpContentBoxP2 {
    margin-top: 20px;
    font-size: 6px;
    color: #999;
}

.tpContentBox .tpContentBoxP2 .spanMargin {
    margin: 0 2px;
}

#btnBox .statusColor {
    font-size: .7rem;
    font-weight: 400;
}

.footer {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep#didia .el-dialog {
    margin-top: 6vh !important;
}

::v-deep#didia .el-dialog__body {
    overflow-x: auto;
    height: 700px;
}

/* ::v-deep .ql-align-center {
    text-align: center;
    padding-top: 20px;
} */
::v-deep #didia .noticemain h1 {
    text-align: center;
}

::v-deep #didia .noticemain p:nth-child(2) {
    text-align: center;
}
</style>
